import { ajax } from "./axios";

 export const getRgzntsLoginTicket = () => {
   return ajax({
     url: "/rgznts/sso/ticket/create",
     method: "post",
     headers: {
       isToken: true,
     },
   });
 };

 export const getJtx2026LoginTicket = () => {
   return ajax({
     url: "/jtx-2026/sso/ticket/create",
     method: "post",
     headers: {
       isToken: true,
     },
   });
 };
